import Supervisor from "./Supervisor";
export default Supervisor;